import { computed } from 'vue';
import { useOrganizationsStore } from '@/stores/organizations';
import type { UpdateMemberRoleRequest } from '../types';

export function useOrganizationMembers(organizationId?: string) {
  const store = useOrganizationsStore();

  const targetId = computed(() => organizationId || store.currentOrganizationId);

  const members = computed(() => {
    const id = targetId.value;
    return id ? store.currentMembers : [];
  });

  const fetchMembers = async () => {
    const id = targetId.value;
    if (id) {
      await store.fetchMembers(id);
    }
  };

  const updateMemberRole = async (userId: string, role: UpdateMemberRoleRequest['role']) => {
    const id = targetId.value;
    if (id) {
      await store.updateMemberRole(userId, { role });
    }
  };

  const removeMember = async (userId: string) => {
    const id = targetId.value;
    if (id) {
      await store.removeMember(userId);
    }
  };

  const leaveOrganization = async () => {
    const id = targetId.value;
    if (id) {
      await store.leaveOrganization(id);
    }
  };

  const transferOwnership = async (userId: string, password: string) => {
    await store.transferOwnership(userId, password);
  };

  return {
    members,
    isLoading: computed(() => store.isLoading),
    error: computed(() => store.error),

    fetchMembers,
    updateMemberRole,
    removeMember,
    leaveOrganization,
    transferOwnership,
  };
}
